import { NgModule, ErrorHandler } from '@angular/core';
import { IonicModule, IonicErrorHandler } from 'ionic-angular';
import { PageRef } from '../../core/core.module';

import { MenuMorePage } from './pages/menu-more/menu-more';
import { MenuMoreCommon } from './pages/menu-more/menu-more.common';

import { IonImgCache } from '../ionic2-img-cache/ion-img-cache';

//Export
export { MenuMorePage } from './pages/menu-more/menu-more';

@NgModule({
    imports: [
        IonicModule,
        IonImgCache
    ],
    declarations: [
        MenuMorePage,
    ],
    exports: [
        MenuMorePage
    ],
    bootstrap: [],
    entryComponents: [
        MenuMorePage
    ],
    providers: [{provide: ErrorHandler, useClass: IonicErrorHandler}, MenuMoreCommon]
})
export class MenuMoreModule{
    constructor(public pageRef: PageRef){
       this.pageRef.addCfgLinks([
            { component: MenuMorePage, name: 'MenuMore', segment: 'menu-more' }
        ]) 
    }
}


// WEBPACK FOOTER //
// ./src/modules/menu-more/menu-more.module.ts